import intl from "react-intl-universal";
import {
  TbAdjustmentsHorizontal,
  TbBuildingBank,
  TbCalendar,
  TbCoins,
  TbSwitchHorizontal,
} from "react-icons/tb";
import { ModernFilterBar } from "../../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  CheckboxListFilterPanel,
  DateFilterPanel,
} from "../../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_ACCOUNTS_FILTERS,
  buildBaasAccountsFilterTags,
  getBaasAccountCurrencyOptions,
  getBaasAccountEntityOptions,
  getBaasAccountStatusOptions,
  getBaasAccountTypeOptions,
  hasActiveBaasAccountsFilters,
  isBaasAccountsChipFilterActive,
  removeBaasAccountsFilterTag,
} from "../baasAccountsFilters";

export const BaasAccountsFilterBar = ({ filters, onFiltersChange, filteredItems, accounts = [] }) => {
  const entitySource = accounts.length ? accounts : filteredItems;
  const entityOptions = getBaasAccountEntityOptions(entitySource);

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("baas.accounts.filterDate"),
      active: isBaasAccountsChipFilterActive(filters, "date"),
    },
    {
      id: "entity",
      icon: TbBuildingBank,
      label: intl.get("baas.accounts.filterEntity"),
      active: isBaasAccountsChipFilterActive(filters, "entity"),
    },
    {
      id: "currency",
      icon: TbCoins,
      label: intl.get("baas.accounts.filterCurrency"),
      active: isBaasAccountsChipFilterActive(filters, "currency"),
    },
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("baas.accounts.filterStatus"),
      active: isBaasAccountsChipFilterActive(filters, "status"),
    },
    {
      id: "type",
      icon: TbSwitchHorizontal,
      label: intl.get("baas.accounts.filterType"),
      active: isBaasAccountsChipFilterActive(filters, "type"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "entity":
        return (
          <CheckboxListFilterPanel
            options={entityOptions}
            selectedValues={draft.entityIds}
            onChange={(entityIds) => onChange({ ...draft, entityIds })}
            idPrefix="baas-accounts-entity"
          />
        );
      case "currency":
        return (
          <CheckboxListFilterPanel
            options={getBaasAccountCurrencyOptions()}
            selectedValues={draft.currencies}
            onChange={(currencies) => onChange({ ...draft, currencies })}
            idPrefix="baas-accounts-currency"
          />
        );
      case "status":
        return (
          <CheckboxListFilterPanel
            options={getBaasAccountStatusOptions()}
            selectedValues={draft.statuses}
            onChange={(statuses) => onChange({ ...draft, statuses })}
            idPrefix="baas-accounts-status"
          />
        );
      case "type":
        return (
          <CheckboxListFilterPanel
            options={getBaasAccountTypeOptions()}
            selectedValues={draft.types}
            onChange={(types) => onChange({ ...draft, types })}
            idPrefix="baas-accounts-type"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_ACCOUNTS_FILTERS}
      searchPlaceholder={intl.get("baas.accounts.searchPlaceholder")}
      filterButtons={filterButtons}
      buildFilterTags={(currentFilters) =>
        buildBaasAccountsFilterTags(currentFilters, entitySource)
      }
      hasActiveFilters={hasActiveBaasAccountsFilters}
      removeFilterTag={removeBaasAccountsFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      panelTitles={{
        date: intl.get("baas.accounts.filterDate"),
        entity: intl.get("baas.accounts.filterEntity"),
        currency: intl.get("baas.accounts.filterCurrency"),
        status: intl.get("baas.accounts.filterStatus"),
        type: intl.get("baas.accounts.filterType"),
      }}
    />
  );
};
